module.exports = __webpack_public_path__ + "static/7i-bf72679ca22e53320beaea090e8bb07d.woff";